import {Component, effect, inject, ViewEncapsulation,} from '@angular/core';
import {TableVerticalControlComponent} from 'frontier/browserkit';
import {ProcessOverviewStore} from '../../service/process-overview.store';
import {MatProgressBar} from '@angular/material/progress-bar';
import AppControlGuids from '../../../../../api/ControlGuids';
import {
  TableVerticalControlCoreComponent
} from "frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control-core/table-vertical-control-core.component";

@Component({
  selector: 'kpi4me-transport-detail',
  templateUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.html',
  styleUrls: [
    './transport-detail.component.scss',
    '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.scss'
  ],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [TableVerticalControlCoreComponent, MatProgressBar]
})
export class TransportDetailComponent extends TableVerticalControlComponent {
  private _processOverviewService = inject(ProcessOverviewStore);
  override GUID = AppControlGuids.TTransportList;

  private selectedCart = this._processOverviewService.selectedCart;

  constructor() {
    super();
    effect(() => {
      const selectedCart = this.selectedCart();
      console.log(selectedCart);
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj
        });
      }
    }, {allowSignalWrites: true});
  }
}
